export default __webpack_public_path__ + "static/img-continue-capital-05c88132dc05de3933e7c923720d26ee.png";